<template>
  <div class="sc-wrapper">
    <intro-button
      class="intro-button"
      :is-loading="false"
      :on-click="handleOnClick"
      v-if="!isPlayingAnimation"
      transition="fade"
      tabIndex="8"
    ></intro-button>
    <div :class="{ 'intro-container': true, 'is-playing-animation': isPlayingAnimation }">
      <h1 class="activity-title" v-if="!isPlayingAnimation" transition="fade">
        Spot Check
      </h1>
      <h2 class="activity-subtitle" v-if="!isPlayingAnimation" transition="fade">
        {{ activityTitle.display }}
      </h2>
      <video
        v-show="!isPlayingAnimation"
        id="animation-video-background"
        playsinline
        ref="spotCheckIntroVideo"
        crossorigin="anonymous"
      >
        <source :src="spotCheckVideo?.src" />
      </video>
      <video
        v-show="isPlayingAnimation"
        id="animation-video"
        playsinline
        ref="spotCheckIntroVideo"
        crossorigin="anonymous"
      ></video>
      <video-player-controls
        v-show="isPlayingAnimation"
        :video="spotCheckVideo"
        :videoReference="this.$refs.spotCheckIntroVideo"
      />
    </div>

    <portal v-if="isPlayingAnimation" to="next-activity-button">
      <next-activity-button :on-click="onComplete" removeTabIndex></next-activity-button>
    </portal>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex';
import AssetLoader from 'mixins/AssetLoader';
import IntroButton from 'components/buttons/IntroButton.vue';
import VideoPlayerControls from '../utils/VideoPlayerControls.vue';
import NextActivityButton from 'components/activity/NextActivityButton.vue';

export default {
  props: {
    onComplete: {
      type: Function,
      default: () => {}
    }
  },

  components: { IntroButton, VideoPlayerControls, NextActivityButton },

  mixins: [AssetLoader],

  data() {
    return {
      isPlayingAnimation: false
    };
  },
  computed: {
    ...mapState('application', ['device', 'video']),
    ...mapGetters('activity', ['activityTitle', 'spotCheckVideo'])
  },

  methods: {
    handleOnClick() {
      this.isPlayingAnimation = true;

      this.videoRef = this.$refs.spotCheckIntroVideo;
      this.videoRef.play();
      document.querySelector('.pure-button')?.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/fade.scss';

.tablet {
  .sc-wrapper {
    height: 100%;
    width: 100%;
  }
}

.sc-wrapper {
  position: relative;
  width: 1024px;
  max-width: 100vw;
  height: 768px;
  overflow: hidden;
  // background: linear-gradient(to bottom, #0098ff 0%, #59c8fe 74%, #027d01 74%, #027d01 100%);

  .intro-button {
    position: 'absolute';
    top: 40%;
    z-index: 3;
  }

  .is-playing-animation {
    background-color: black;
  }

  .intro-container {
    z-index: 2;
    position: relative;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;

    .activity-title,
    .activity-subtitle {
      z-index: 2;
      display: flex;
      justify-content: center;
    }

    #animation-video {
      position: absolute;
      height: calc(100% - 62px) !important;
      max-width: 100%;
      width: auto !important;
      top: 0;
      z-index: 1;
    }

    #animation-video-background {
      position: absolute;
      height: 100% !important;
      max-width: 100%;
      width: auto !important;
      top: 0;
      z-index: 1;
    }

    .player-controls-container {
      position: absolute;
      width: 100% !important;
      bottom: 0;
      z-index: 1000;
    }
  }
}
</style>
